import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { QuickAddModal } from '../components/QuickAddModal'
import {
  actionCreators,
  IQuickAddState,
  selectContact,
  selectError,
  selectForceIsCompany,
  selectIsOpen,
  selectIsSaving,
  selectSourceId,
} from '../modules/quickAdd'

export default connect(
  createStructuredSelector<ApplicationState, IQuickAddState>({
    contact: selectContact(),
    error: selectError(),
    forceIsCompany: selectForceIsCompany(),
    isOpen: selectIsOpen(),
    isSaving: selectIsSaving(),
    sourceId: selectSourceId(),
  }),
  actionCreators,
)(QuickAddModal)
